module.exports = __webpack_public_path__ + "img/attendanceLack.e1a15fa0.svg";